import { useContext } from "react";
import { UserContext, User } from "@/shared/lib/context/UserContext";

export const useUser = () => {
    const context = useContext(UserContext);

    const setUser = (user: User | string) => {
        if (context.setUser) {
            context.setUser(user);
        }
    };

    const setToken = (token: string) => {
        if (context.setToken) {
            context.setToken(token);
        }
    };

    const logout = () => {
        if (context.logout) {
            context.logout();
        }
    };

    return {
        user: context.user,
        token: context.token,
        setUser,
        setToken,
        logout,
        isAuthenticated: context.isAuthenticated,
    };
};
